import { categoryDetailLinkListStyles } from "@insite/content-library/Widgets/Category/CategoryDetailLinkList";
import { css } from "styled-components";

categoryDetailLinkListStyles.container = {
    gap: 0,
    offsetCss: css`
        width: 100% !important;
        margin: 0px !important;
    `,
};

categoryDetailLinkListStyles.subCategoryNameLinkItem = {
    width: 12,
    css: css`
        margin-bottom: 5px !important;
        background-color: #f3efeb;
        border-radius: 4px;
        padding-top: 10px;
        padding-bottom: 10px;
        padding-left: 20px;
        padding-right: 20px;
    `,
};

categoryDetailLinkListStyles.subCategoryNameLink = {
    color: "primary",
    css: css`
        font-family: "Lato";
    `,
};
